import util from 'util';
import { CONSTANT } from '@const';
import { Address, AddressParsePayload, AddressParseResponse, AddressSearchPayload } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';
import addressesData from './../../utils/sampleData/addresses.json';

const addresses: Address[] = JSON.parse(JSON.stringify(addressesData));

export class AddressService extends ApiService {
	static async search(text: string): Promise<string[]> {
		const maxResultsNumber = 20;
		const minSearchLength = 4;
		const isValidToSearch = minSearchLength <= text.length;
		const payload: AddressSearchPayload = { search: text };
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.ADDRESS_SEARCH_API_URL),
			data: payload,
		};

		return isValidToSearch
			? this.executeApiRequest(params).then((data: string[]) => {
					data.splice(maxResultsNumber);
					return data;
				})
			: new Promise(resolve => resolve([]));
	}

	static async parseToValidAddress(rawAddress: string): Promise<Address> {
		// console.log('%cParsing address...', 'color: hotpink');
		const parseResponseData = await AddressService.parse(rawAddress);
		const parsedAddress = parseResponseData.results[0];
		// console.log('%cParse response data', 'color: hotpink');
		// console.log(parseResponseData);
		// console.log('%cParsed address', 'color: hotpink');
		// console.log(parsedAddress);
		// console.log('%cValidating address...', 'color: hotpink');
		// const validatedAddressess = await AddressService.validate(parsedAddress);
		// const validatedAddress = validatedAddressess[0];
		// console.log('%cValidated address', 'color: hotpink');
		// console.log(validatedAddress);
		return parsedAddress;
	}

	private static async parse(rawAddress: string): Promise<AddressParseResponse> {
		const payload: AddressParsePayload = { address: rawAddress };
		const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.ADDRESS_PARSE_API_URL),
			data: payload,
		};
		return this.executeApiRequest(params);
	}

	private static async validate(address: Address): Promise<Address[]> {
		// TODO: commented until implemented API
		/* const params: ApiParams = {
			method: 'POST',
			url: util.format(CONSTANT.ADDRESS_VALIDATE_API_URL),
			data: address,
		};
		return this.executeApiRequest(params); */

		const validAddresses = addresses.find(
			addressMock => AddressService.mapAddress(addressMock) == AddressService.mapAddress(address),
		);

		return validAddresses ? [validAddresses] : addresses;
	}

	private static mapAddress(address?: Address): string {
		return [
			address?.addressLine1,
			address?.addressLine2,
			address?.suburb,
			[address?.state, address?.postalCode].filter(str => str && str.length > 0).join(' '),
		]
			.filter(str => str && str.length > 0)
			.join(', ');
	}
}
